import { render, staticRenderFns } from "./AddProfessional.vue?vue&type=template&id=f4ffbb00&"
import script from "./AddProfessional.vue?vue&type=script&lang=js&"
export * from "./AddProfessional.vue?vue&type=script&lang=js&"
import style0 from "./AddProfessional.vue?vue&type=style&index=0&id=f4ffbb00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports